const RAW_WHATSAPP = '50768226048';

const site = {
  legalName: 'Soluciones e Integraciones Eléctricas, S.A.',
  shortName: 'SIESA',
  foundedYear: 2019,

  phone: { label: '+507 211-4708', href: 'tel:+5072114708' },
  mobile: { label: '+507 6822-6048', href: 'tel:+50768226048' },

  whatsapp: {
    number: RAW_WHATSAPP,
    label: '+507 6822-6048',
    defaultMessage:
      'Hola, necesito información sobre las soluciones de SIESA.',
    href(message) {
      const text = message || site.whatsapp.defaultMessage;
      return `https://wa.me/${RAW_WHATSAPP}?text=${encodeURIComponent(text)}`;
    },
  },

  email: {
    label: 'gerenciaventas@siesa.com.pa',
    href: 'mailto:gerenciaventas@siesa.com.pa',
  },

  location: { label: 'Ciudad de Panamá, Panamá', short: 'Ciudad de Panamá' },

  hours: {
    weekdays: 'Lunes a viernes, 8:00 a. m. – 5:00 p. m.',
    saturday: 'Sábados, 8:00 a. m. – 1:00 p. m.',
  },

  social: {
    instagram: {
      label: 'Instagram',
      href: 'https://instagram.com/siesa_pty',
    },
  },

  siesaAppUrl: 'https://almacenamientoweb-siesa.com/',
  siteUrl: 'https://siesa.com.pa',
};

export default site;
